import React from "react";
import { Link } from "react-router-dom";
import { Radio } from "lucide-react";

export default function Terms() {
  return (
    <div className="min-h-screen bg-[#0B0E14] text-white" data-testid="terms-page">
      <header className="h-16 border-b border-[#1E2638] px-6 flex items-center justify-between">
        <Link to="/" className="flex items-center gap-3">
          <div className="w-9 h-9 rounded-lg bg-gradient-to-br from-[#00F0FF] to-[#FF2A6D] flex items-center justify-center">
            <Radio className="w-5 h-5 text-black" strokeWidth={2.5}/>
          </div>
          <div className="font-display font-black text-xl tracking-tight">NEURAL<span className="text-[#00F0FF]">DECK</span></div>
        </Link>
      </header>
      <main className="max-w-3xl mx-auto px-6 py-12">
        <div className="font-mono text-xs uppercase tracking-[0.3em] text-[#00F0FF] mb-2">// Legal</div>
        <h1 className="font-display font-black text-4xl sm:text-5xl mb-6">Terms of Service</h1>
        <p className="text-[#94A3B8] text-sm mb-8">Last updated: 13 August 2026</p>

        <section className="space-y-6 text-[#F8FAFC] text-sm leading-relaxed">
          <p>By using NeuralDeck you agree to these terms. If you do not agree, do not use the Service.</p>

          <h2 className="font-display font-black text-2xl text-white mt-8">1. Account & content</h2>
          <p>You are responsible for maintaining the confidentiality of your account. You retain ownership of the content you upload or publish. By publishing a set, you grant NeuralDeck a non-exclusive worldwide license to host and stream it via the public set page you choose to share.</p>

          <h2 className="font-display font-black text-2xl text-white mt-8">2. Music rights</h2>
          <p>You are responsible for holding the rights to any audio you upload, mix, publish, or broadcast. NeuralDeck does not grant any performance, mechanical, or sync license. Do not upload, publish, or broadcast copyrighted material you don't have the right to use.</p>

          <h2 className="font-display font-black text-2xl text-white mt-8">3. Spotify metadata</h2>
          <p>Spotify integration displays track metadata and 30-second previews from your Spotify library through Spotify's official APIs. Full-track playback of Spotify audio for mixing is not provided by our Service.</p>

          <h2 className="font-display font-black text-2xl text-white mt-8">4. Payments</h2>
          <p>PRO subscriptions are processed by Stripe. Subscriptions renew automatically until cancelled. You can cancel at any time from your Stripe customer portal. Refund policy: within 7 days of first payment we will refund on request; after that, subscriptions are non-refundable.</p>

          <h2 className="font-display font-black text-2xl text-white mt-8">5. Prohibited use</h2>
          <ul className="list-disc pl-6 space-y-2">
            <li>Uploading unlawful, hateful, or infringing content.</li>
            <li>Attempting to reverse-engineer, scrape, or attack the Service.</li>
            <li>Impersonating other users or DJs.</li>
          </ul>

          <h2 className="font-display font-black text-2xl text-white mt-8">6. Disclaimer</h2>
          <p>The Service is provided "as is" without warranties of any kind. To the fullest extent permitted by law, our total liability for any claim is limited to the amount you paid us in the last 12 months.</p>

          <h2 className="font-display font-black text-2xl text-white mt-8">7. Contact</h2>
          <p>Questions? Reach us at <a href="mailto:hello@neuraldeck.app" className="text-[#00F0FF] hover:underline">hello@neuraldeck.app</a>.</p>
        </section>

        <div className="mt-16 pt-8 border-t border-[#1E2638] text-center">
          <Link to="/" className="text-[#00F0FF] font-black uppercase tracking-widest text-sm">← Back to NeuralDeck</Link>
        </div>
      </main>
    </div>
  );
}
